import React from 'react';
import s from './TagSelector.scss';
import cx from 'classnames';
import Tag from '../Tag/Tag';
import { TransitionGroup } from 'react-transition-group';
import ScaleFade from '../../animations/ScaleFade';

var TagsSelector = function TagsSelector(props) {
  var onTagSelected = props.onTagSelected,
      t = props.t,
      selectedTags = props.selectedTags,
      rowCounts = props.rowCounts,
      templateTags = props.templateTags,
      isMobile = props.isMobile;
  var templateTagsCopy = [].concat(templateTags);
  var rows = [];

  while (templateTagsCopy.length) {
    for (var i = 0; i < rowCounts.length; i++) {
      var count = rowCounts[i];
      var tagsRow = templateTagsCopy.splice(0, count);

      if (tagsRow.length > 0) {
        rows.push(tagsRow);
      } else {
        break;
      }
    }
  }

  var currentIndex = 0;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(s.container, 'tags-selector')
  }, rows.map(function (row, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: s.row
    }, /*#__PURE__*/React.createElement(TransitionGroup, null, row.map(function (tag, x) {
      currentIndex++;
      return /*#__PURE__*/React.createElement(ScaleFade, {
        key: x,
        delay: 200 + currentIndex * 30
      }, /*#__PURE__*/React.createElement(Tag, {
        dataAid: "tag-" + tag.key,
        key: tag.key,
        tagDisplayName: t(tag.label),
        isSelected: selectedTags.indexOf(tag.key) !== -1,
        onTagClick: function onTagClick() {
          return onTagSelected(tag.key);
        },
        tagSelectedColor: tag.selectedColor,
        isMobile: isMobile
      }));
    })));
  }));
};

export default TagsSelector;